import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VExpandTransition } from 'vuetify/lib/components/transitions';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    VCard,
    { staticClass: "mb-2", attrs: { elevation: "1" } },
    [
      _c(
        "div",
        {
          staticClass:
            "workpackage-header pa-2 px-4 d-flex justify-space-between align-center",
        },
        [
          _c("div", { staticClass: "d-flex align-center" }, [
            _vm.workpackage.mocked
              ? _c(
                  "div",
                  { staticClass: "progress-spinner-container mr-2" },
                  [
                    _c("progress-spinner", {
                      attrs: {
                        "job-id": _vm.workpackage.description,
                        "job-type": _vm.workpackage.isCloneJob
                          ? "run_clone_workpackage"
                          : "run_create_workpackage",
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "a",
              {
                staticClass: "workpackage-title font-weight-bold mr-6",
                attrs: { "e2e-slug": "linkWPNew" },
                on: { click: _vm.selectWorkpackageHandle },
              },
              [_vm._v(_vm._s(_vm.workpackage.description))]
            ),
            _vm._v(" "),
            _c(
              "span",
              { staticClass: "workpackage-meta" },
              [
                _c("span", { staticClass: "meta-label" }, [
                  _vm._v(
                    _vm._s(_vm.$t("workPackages.sourceWorkpackage")) + ":"
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "span",
                  { staticClass: "meta-value" },
                  [
                    _c("tooltipped-truncated-field", {
                      attrs: {
                        text:
                          _vm.workpackage.sourceWorkpackageDescription ===
                          undefined
                            ? _vm.workpackage.storeFormat
                            : _vm.workpackage.sourceWorkpackageDescription,
                        "truncation-length": 35,
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "feature-toggle",
                  { attrs: { toggle: "enableWorkpackagePeriodTypes" } },
                  [
                    _vm.periodTypeBadge
                      ? [
                          _c("span", { staticClass: "mx-2" }, [_vm._v("|")]),
                          _vm._v(" "),
                          _c(
                            VTooltip,
                            {
                              attrs: { bottom: "" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "activator",
                                    fn: function ({ on, attrs }) {
                                      return [
                                        _c(
                                          "span",
                                          _vm._g(
                                            _vm._b(
                                              {
                                                staticClass:
                                                  "period-type-badge mr-1",
                                              },
                                              "span",
                                              attrs,
                                              false
                                            ),
                                            on
                                          ),
                                          [
                                            _vm._v(
                                              _vm._s(_vm.periodTypeBadge.label)
                                            ),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                2789481397
                              ),
                            },
                            [
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(_vm._s(_vm.periodTypeBadge.tooltip)),
                              ]),
                            ]
                          ),
                        ]
                      : _vm._e(),
                  ],
                  2
                ),
                _vm._v(" "),
                _c(
                  "feature-toggle",
                  { attrs: { toggle: "enableReferenceDate" } },
                  [
                    !_vm.periodTypeBadge
                      ? _c("span", { staticClass: "mx-2" }, [_vm._v("|")])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("span", { staticClass: "meta-label" }, [
                      _vm._v(
                        _vm._s(_vm.$t("workPackages.referenceDate")) + ":"
                      ),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "meta-value" }, [
                      _vm._v(
                        _vm._s(
                          _vm.getReferenceDate(_vm.workpackage.referenceDate)
                        )
                      ),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c("span", { staticClass: "mx-2" }, [_vm._v("|")]),
                _vm._v(" "),
                _c("span", { staticClass: "meta-label" }, [
                  _vm._v(_vm._s(_vm.$t("workPackages.completionDate")) + ":"),
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "meta-value" }, [
                  _vm._v(
                    _vm._s(
                      _vm.formatLocalisedDate(_vm.workpackage.completionDate)
                    )
                  ),
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "mx-1" }, [_vm._v("/")]),
                _vm._v(" "),
                _c("span", { staticClass: "meta-label" }, [
                  _vm._v(_vm._s(_vm.$t("workPackages.goLiveDate")) + ":"),
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "meta-value" }, [
                  _vm._v(
                    _vm._s(_vm.formatLocalisedDate(_vm.workpackage.goLiveDate))
                  ),
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "mx-2" }, [_vm._v("|")]),
                _vm._v(" "),
                _c("span", { staticClass: "meta-label" }, [
                  _vm._v(_vm._s(_vm.$t("workPackages.owner")) + ":"),
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "meta-value" }, [
                  _vm._v(_vm._s(_vm.workpackage.owner)),
                ]),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "d-flex" },
            [
              _vm.isCreateWorkpackageFromCopyEnabled &&
              _vm.allowCopy &&
              _vm.canEditWorkpackage
                ? _c(
                    VBtn,
                    {
                      staticClass: "header-icon-btn",
                      attrs: { disabled: _vm.disabled(), icon: "", small: "" },
                    },
                    [
                      _c(
                        VIcon,
                        {
                          attrs: { small: "" },
                          on: { click: _vm.emitOpenWorkpackageCopyDialog },
                        },
                        [_vm._v("mdi-content-copy")]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.workpackage.type !== _vm.workpackageTypes.master
                ? _c(
                    VBtn,
                    {
                      staticClass: "header-icon-btn",
                      attrs: {
                        disabled: _vm.disabled(),
                        loading: _vm.deleting(),
                        "e2e-slug": "btnDeleteWPNew",
                        icon: "",
                        small: "",
                      },
                      on: { click: _vm.emitOpenDeleteDialog },
                    },
                    [
                      _c(VIcon, { attrs: { small: "" } }, [
                        _vm._v("mdi-trash-can-outline"),
                      ]),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                VBtn,
                {
                  staticClass: "header-icon-btn",
                  attrs: { icon: "", small: "" },
                  on: { click: _vm.toggleExpanded },
                },
                [
                  _c(VIcon, { attrs: { small: "" } }, [
                    _vm._v(
                      _vm._s(
                        _vm.isExpanded ? "mdi-chevron-up" : "mdi-chevron-down"
                      )
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      !_vm.isExpanded
        ? _c(
            "div",
            { staticClass: "collapsed-pricing-groups px-2" },
            [
              _c("workpackage-pricing-groups", {
                attrs: { workpackage: _vm.workpackage, "collapsed-view": true },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(VExpandTransition, [
        _vm.isExpanded
          ? _c(
              "div",
              { staticClass: "workpackage-expanded-content-wrapper px-4" },
              [
                _c(
                  "div",
                  { staticClass: "workpackage-expanded-content" },
                  [
                    _c(
                      VRow,
                      {
                        staticClass: "expanded-container",
                        attrs: { "no-gutters": "" },
                      },
                      [
                        _c(
                          VCol,
                          {
                            staticClass:
                              "workpackage-info-container sidebar-col my-4 pr-4",
                          },
                          [
                            _c("workpackage-info", {
                              attrs: {
                                workpackage: _vm.workpackage,
                                "store-group": _vm.storeGroup,
                                "select-workpackage":
                                  _vm.selectWorkpackageHandle,
                              },
                            }),
                            _vm._v(" "),
                            _c("workpackage-ao-extracts", {
                              attrs: { workpackage: _vm.workpackage },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          VCol,
                          {
                            staticClass: "pricing-groups-container content-col",
                          },
                          [
                            _c("div", { staticClass: "pl-4 py-4" }, [
                              _c(
                                "div",
                                { staticClass: "grey--text text-center" },
                                [
                                  _c("workpackage-pricing-groups", {
                                    attrs: { workpackage: _vm.workpackage },
                                  }),
                                ],
                                1
                              ),
                            ]),
                          ]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "workpackage-footer pa-4" },
                  [
                    _c(
                      VRow,
                      {
                        staticClass: "expanded-container justify-end",
                        attrs: { "no-gutters": "" },
                      },
                      [
                        _c(
                          "feature-toggle",
                          {
                            attrs: { toggle: "displayExportPenaltyDataButton" },
                          },
                          [
                            _c(
                              VBtn,
                              {
                                staticClass: "ml-2",
                                attrs: {
                                  small: "",
                                  color: "primary",
                                  loading: _vm.loadingPenaltyExports,
                                  depressed: "",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.exportPenaltyData({
                                      workpackage: _vm.workpackage,
                                    })
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.$t("actions.downloadPenaltyData")
                                    ) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "feature-toggle",
                          { attrs: { toggle: "displayExportToSAPButton" } },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "api-export-container d-inline-flex align-center",
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "last-export-info mr-2" },
                                  [
                                    _vm.hasExportInfo(
                                      _vm.workpackage._id,
                                      _vm.exportType.exportToSAP
                                    )
                                      ? _c(
                                          "div",
                                          {
                                            staticClass: "d-flex align-center",
                                          },
                                          [
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(
                                                  _vm.getExportLastText(
                                                    _vm.workpackage._id,
                                                    _vm.exportType.exportToSAP
                                                  )
                                                ) +
                                                "\n                "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                ),
                                _vm._v(" "),
                                _c("sap-export-button", {
                                  attrs: {
                                    disabled:
                                      _vm.disabled() || _vm.disableOWUserExport,
                                    loading: _vm.exportingToSAP(),
                                    params: _vm.sapExportParams,
                                  },
                                  on: {
                                    downloadExportToSAP:
                                      _vm.emitTriggerDownloadExportToSap,
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "feature-toggle",
                          { attrs: { toggle: "displayExportToAPIButton" } },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "api-export-container d-inline-flex align-center",
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "last-export-info mr-2" },
                                  [
                                    _vm.hasExportInfo(_vm.workpackage._id)
                                      ? _c(
                                          "div",
                                          {
                                            staticClass: "d-flex align-center",
                                          },
                                          [
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(
                                                  _vm.getExportLastText(
                                                    _vm.workpackage._id
                                                  )
                                                ) +
                                                "\n                "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  VBtn,
                                  {
                                    staticClass: "ml-2",
                                    attrs: {
                                      small: "",
                                      disabled:
                                        _vm.disabled() ||
                                        _vm.disableOWUserExport,
                                      loading: _vm.posting(),
                                      color: "primary",
                                      "e2e-slug": "btnPostPricingNew",
                                      depressed: "",
                                    },
                                    on: { click: _vm.emitOpenExportAPIDialog },
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(_vm.$t("actions.postPricing")) +
                                        "\n              "
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _vm.displayGoLiveDateDialog
                          ? _c(
                              "span",
                              [
                                _c(
                                  VBtn,
                                  {
                                    staticClass: "ml-2",
                                    attrs: {
                                      small: "",
                                      disabled: _vm.disabled(),
                                      loading: _vm.exporting(),
                                      color: "primary",
                                      outlined: "",
                                      "e2e-slug": "btnExportPricingNew",
                                      depressed: "",
                                    },
                                    on: {
                                      click: _vm.emitOpenExportPricingDialog,
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(
                                          _vm.$t("actions.downloadPricing")
                                        ) +
                                        "\n            "
                                    ),
                                  ]
                                ),
                              ],
                              1
                            )
                          : !_vm.isXSRClient
                          ? _c(
                              "span",
                              [
                                _c(
                                  VBtn,
                                  {
                                    staticClass: "ml-2",
                                    attrs: {
                                      small: "",
                                      disabled: _vm.disabled(),
                                      loading: _vm.exporting(),
                                      color: "primary",
                                      outlined: "",
                                      "e2e-slug": "btnExportPricingNew",
                                      depressed: "",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.downloadWorkpackageResults({
                                          selectedWorkpackage: _vm.workpackage,
                                          fields: _vm.fields,
                                          exportType:
                                            _vm.exportType.exportPricing,
                                          columnFormatters:
                                            _vm.columnFormatters,
                                        })
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(
                                          _vm.$t("actions.downloadPricing")
                                        ) +
                                        "\n            "
                                    ),
                                  ]
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          VBtn,
                          {
                            staticClass: "ml-2",
                            attrs: {
                              small: "",
                              disabled: _vm.disabled(),
                              loading: _vm.transferring(),
                              color: "primary",
                              "e2e-slug": "btnTransferWorkpackageNew",
                              depressed: "",
                            },
                            on: { click: _vm.emitOpenTransferDialog },
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm.$t("workPackages.transferWorkpackage")
                                ) +
                                "\n          "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            )
          : _vm._e(),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }